'use client';

import QuoteIcon from '@mui/icons-material/DescriptionOutlined';
import { Paper, Typography, Stack } from '@mui/material';
export const NoQuotesFound = () => {
  return <Paper sx={{
    my: 2,
    p: 2,
    display: 'flex',
    gap: 2,
    border: 'none'
  }} data-sentry-element="Paper" data-sentry-component="NoQuotesFound" data-sentry-source-file="NoQuotesFound.tsx">
      <Stack sx={{
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      bgcolor: 'secondary.12p',
      width: 55,
      height: 55,
      borderRadius: '50%'
    }} data-sentry-element="Stack" data-sentry-source-file="NoQuotesFound.tsx">
        <QuoteIcon color="secondary" sx={{
        fontSize: 26
      }} data-sentry-element="QuoteIcon" data-sentry-source-file="NoQuotesFound.tsx" />
      </Stack>
      <div>
        <Typography component="h2" sx={{
        typography: {
          xs: 'h4',
          sm: 'h3'
        }
      }} data-sentry-element="Typography" data-sentry-source-file="NoQuotesFound.tsx">
          No Recent Quotes
        </Typography>
        <Typography data-sentry-element="Typography" data-sentry-source-file="NoQuotesFound.tsx">You have not no quotes yet</Typography>
      </div>
    </Paper>;
};